import * as Sentry from '@sentry/vue'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { MotionPlugin } from '@vueuse/motion'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { createApp } from 'vue'

import App from './App.vue'
import i18n from './assets/lang'

import router from './router/index.ts'
import './assets/css/index.css'
import './assets/css/tailwind.css'

const queryClient = new QueryClient()

const pinia = createPinia()

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://8efbce636c1c3a106c96a3c6b35fd3a3@o729097.ingest.us.sentry.io/4509274697564160',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

app.use(PrimeVue, {
  theme: 'none',
})
app.use(ToastService)
app.directive('tooltip', Tooltip)
app.use(router).use(VueQueryPlugin, { queryClient }).use(pinia)

app.use(i18n)
app.use(MotionPlugin)
app.mount('#app')
